import { NETWORK_ERROR, NETWORK_ERROR_FOR_DISPLAY } from 'consts';

export const checkNetworkErrorFormat = (code?: string) => {
  if (code === NETWORK_ERROR) {
    return `${NETWORK_ERROR_FOR_DISPLAY}`;
  }
  return code || '';
};
